import { TBrowserAppType } from "../../interface";

export function getRandomInt(
  min: number,
  max: number,
  excludedValues: number[]
) {
  let randomNum;
  do {
    randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (excludedValues.includes(randomNum));
  return randomNum;
}

export class IntervalTimer {
  public state: "IDLE" | "RUNNING" | "PAUSE" | "STOP";
  public fired: number;
  private timerId: NodeJS.Timeout | undefined;
  private resumeId: NodeJS.Timeout | undefined;

  public remaining: number;
  private lastTimeRun: number;
  private lastPauseTime: number;
  private pausedTime: number;

  constructor(
    private cb: (self: IntervalTimer) => void,
    private interval: number
  ) {
    this.state = "IDLE";
    this.fired = 0;
    this.remaining = 0;
    this.pausedTime = 0;
    this.lastTimeRun = 0;
    this.lastPauseTime = 0;
  }

  private proxyCb() {
    this.lastTimeRun = Date.now();
    this.cb(this);
    this.fired++;
  }
  private timeoutCb() {
    if (this.state !== "RUNNING") throw new Error("Timer is not resume");
    this.pausedTime = 0;
    this.proxyCb();
    this.start();
  }

  public start() {
    if (this.state !== "IDLE" && this.state !== "RUNNING")
      throw new Error(`Timer is not iddle ${this.state}`);

    this.timerId = setInterval(this.proxyCb.bind(this), this.interval);
    this.lastTimeRun = Date.now();
    this.state = "RUNNING";
  }

  public pause() {
    if (this.state !== "RUNNING") throw new Error("Timer is not running");

    this.remaining =
      this.interval - (Date.now() - this.lastTimeRun) + this.pausedTime;
    this.lastPauseTime = Date.now();
    clearInterval(this.timerId);
    clearTimeout(this.resumeId);
    this.state = "PAUSE";
  }

  public resume() {
    if (this.state !== "PAUSE") throw new Error("Timer is not paused");
    this.pausedTime += Date.now() - this.lastPauseTime;
    this.resumeId = setTimeout(this.timeoutCb.bind(this), this.remaining);
    this.state = "RUNNING";
  }

  public stop() {
    if (this.state === "IDLE") throw new Error("Timer is in iddle");
    clearInterval(this.timerId);
    clearTimeout(this.resumeId);
    this.state = "IDLE";
  }

  public setInterval(newInterval: number) {
    this.stop();
    this.interval = newInterval;
    this.start();
  }
}

export const browserAppType = () => {
  const ua = navigator.userAgent.toLowerCase();
  let result: TBrowserAppType = "chrome";
  result = ua.includes('safari') && !ua.includes('chrome') ? "safari" : result;
  return result;
};
